import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateDirective } from '../shared/translate.directive';
import { FormsModule } from '@angular/forms';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerLocComponent } from '../mat-datepicker-loc/mat-datepicker-loc.component';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { LanguageProvider } from '../shared/language-provider';
import { getMacedonianPaginatorIntl } from '../custom-paginator-intl';
import { FineService } from '../shared/services/fine.service';
import { Router } from '@angular/router';
import { ErrorComponent } from '../shared/error/error.component';
import { LoginService } from '../shared/services/login.service';

@Component({
  selector: 'app-fines',
  standalone: true,
  imports: [ErrorComponent, CommonModule, TranslateDirective, FormsModule, MatPaginatorModule, MatDatepickerModule, MatInputModule, MatFormFieldModule, MatDatepickerLocComponent, MatIconModule],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'mk-MK' },
    provideNativeDateAdapter(),
    {
      provide: MatPaginatorIntl,
      useFactory: (provider: LanguageProvider) => getMacedonianPaginatorIntl(provider),
      deps: [LanguageProvider]
    }
  ],
  templateUrl: './fines.component.html',
  styleUrl: './fines.component.less',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FinesComponent implements OnInit {

  searchModel: any = {
    ZoneName: null,
    PlateNumber: null
  }
  hasErrors = false;
  errors: any;
  unpaidFines: any;
  totalUnpaidFines: any = 0;
  paidFines: any;
  totalPaidFines: any = 0;
  isLogged = false;
  instanceId: any ='';
  constructor(private fineService: FineService, private router: Router, public loginService: LoginService) {

  }
  ngOnInit() {
    this.loginService.contextChange.subscribe(() => {
      this.isLogged = this.loginService.isAuthenticated();
    });
    this.isLogged = this.loginService.isAuthenticated();

    if (!this.isLogged) {
      
      let instanceId = localStorage.getItem('instanceId');

      if (!instanceId) {
        instanceId = crypto.randomUUID(); 
        localStorage.setItem('instanceId', instanceId);
      }

      this.instanceId = instanceId;
    }

     this.getFineHistory();
  }
  getFines() {
    this.unpaidFines = null;
    this.hasErrors = false;
    this.errors = null;
    this.fineService.getFines(this.searchModel).subscribe((res: any) => {
      this.unpaidFines = res;
      this.totalUnpaidFines = res.length;
    }, error => {
      this.hasErrors = true;
      this.errors = error.error.errors;
    });
  }
  clearFilter() {
    this.hasErrors = false;
    this.errors = null;
    this.searchModel.ZoneName = null;
    this.searchModel.PlateNumber = null;
    this.unpaidFines = null;
    this.totalUnpaidFines = 0;

  }

  pay(model: any) {
    this.router.navigate(['confirm-payment-fines'],
      {
        state: { data: model }
      });
  }
  getFineHistory() {
    
    this.fineService.getFineHistory(this.instanceId).subscribe((res: any) => {
      this.paidFines = res;
      this.totalPaidFines = res.length;
    });
  }
}
